import React from "react";

// <Title></Title>
export const Title = ({ children }) => (
  <div className="title">
    <hr />
    {children}
    <hr />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Modules/Title.js